import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Autocomplete, Divider, TextField, Typography } from '@mui/material';
import api from '../../services/api';
import {
  AutocompleteContainer,
  EmployeeFlexDiv,
  EmployeeName,
  EmployeePosition,
  EmployeeProfile,
  EmployeesPageContainer,
  SelectEmployeeContainer,
  SelectEmployeeLabel,
} from './Employees.Styles';

const Employees = () => {
  const { t } = useTranslation();
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [allDashboards, setAllDashboards] = useState([]);
  const [employeeDashboards, setEmployeeDashboards] = useState([]);
  const [employeeDashboardsUrl, setEmployeeDashboardsUrl] = useState([]);
  const [hasError, setHasError] = useState(false);

  const defaultDashboardInfo = [
    { title: 'Último Relatório IA', width: '100%', height: '300' },
    { title: 'Riscos e Personalidade', width: '100%', height: '720' },
    { title: 'Sono, Humor e Emoções', width: '100%', height: '550' },
    { title: 'Sono, Humor & Emoções', width: '100%', height: '550' },
    { title: 'Comunicações Diárias e Recursos', width: '100%', height: '550' },
    { title: 'Respostas Semanais', width: '100%', height: '550' },
  ];

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [employeeRes, dashboardRes] = await Promise.all([
          api.get('employees'),
          api.get('dashboards'),
        ]);
        setEmployees(employeeRes.data.users);
        setAllDashboards(dashboardRes.data.dashboards);
      } catch (error) {
        console.error('❌ Erro ao buscar dados iniciais:', error);
        setHasError(true);
      }
    };

    fetchInitialData();
  }, []);

  const filteredDashboards = useMemo(() => {
    console.log('allDashboards: ', allDashboards);
    if (!selectedEmployee?.external_id || !allDashboards.length) return [];

    const filtered = allDashboards.filter((d) =>
      d.name.includes(selectedEmployee.external_id)
    );

    console.log(
      '📊 Dashboards filtrados para',
      selectedEmployee.name,
      filtered
    );
    return filtered;
  }, [selectedEmployee, allDashboards]);

  useEffect(() => {
    setEmployeeDashboards(filteredDashboards);
  }, [filteredDashboards]);

  useEffect(() => {
    const fetchEmbedUrls = async () => {
      if (!employeeDashboards.length) return;

      try {
        console.log('employeeDashboards: ', employeeDashboards);
        const response = await api.post('generate-embed-dashboard-url', {
          dashboards: employeeDashboards,
        });

        console.log('response.data: ', response.data);

        const mergedData = response.data.map((resItem) => {
          const matched = employeeDashboards.find(
            (d) => d.dashboardId === resItem.dashboardId
          );
          return {
            ...resItem,
            name: matched?.name || null,
          };
        });

        console.log('mergedData: ', mergedData);
        setEmployeeDashboardsUrl(mergedData);
      } catch (error) {
        console.error('❌ Erro ao buscar embed URLs:', error);
      }
    };

    fetchEmbedUrls();
  }, [employeeDashboards]);

  const handleEmployeeSelect = (event, newValue) => {
    const selected = employees.find((emp) => emp.name === newValue);
    console.log('👤 Employee selecionado:', selected);
    setSelectedEmployee(selected || null);
    setEmployeeDashboards([]);
    setEmployeeDashboardsUrl([]);
  };

  return (
    <EmployeesPageContainer>
      {hasError ? (
        <Typography color="error" variant="h6" sx={{ mt: 2 }}>
          {t('employeesPage.errorLoading')}
        </Typography>
      ) : (
        <>
          <EmployeeFlexDiv>
            <SelectEmployeeContainer>
              <SelectEmployeeLabel>
                {t('employeesPage.selectEmployee')}
              </SelectEmployeeLabel>
              <AutocompleteContainer>
                <Autocomplete
                  size="small"
                  value={selectedEmployee?.name || ''}
                  onChange={handleEmployeeSelect}
                  options={employees.map((e) => e.name)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t('employeesPage.employee')}
                    />
                  )}
                  freeSolo
                />
              </AutocompleteContainer>
            </SelectEmployeeContainer>
            <Divider orientation="vertical" flexItem />
            {selectedEmployee && (
              <EmployeeProfile>
                <EmployeeName>{selectedEmployee.name}</EmployeeName>
                <EmployeePosition>
                  {selectedEmployee.area} - {selectedEmployee.position}
                </EmployeePosition>
              </EmployeeProfile>
            )}
          </EmployeeFlexDiv>

          {defaultDashboardInfo.map((info) => {
            const dynamicTitle = selectedEmployee
              ? `(${selectedEmployee.external_id}) ${info.title}`
              : info.title;

            if (selectedEmployee) {
              console.log('📋 Título dinâmico gerado:', dynamicTitle);
            }

            const matchedDashboard = employeeDashboardsUrl?.find((dash) =>
              dash.name?.toLowerCase().includes(dynamicTitle.toLowerCase())
            );

            console.log('employeeDashboardsUrl: ', employeeDashboardsUrl);
            console.log('matchedDashboard: ', matchedDashboard);

            console.log(
              '🧩 Dashboard encontrado para:',
              dynamicTitle,
              matchedDashboard
            );

            if (!matchedDashboard) return null;

            return (
              <div
                key={matchedDashboard.dashboardId}
                style={{ margin: '16px 0' }}
              >
                <Typography variant="subtitle1" gutterBottom>
                  {dynamicTitle}
                </Typography>
                <iframe
                  title={dynamicTitle}
                  width={info.width}
                  height={info.height}
                  src={matchedDashboard.embedUrl}
                  style={{ border: 'none' }}
                ></iframe>
              </div>
            );
          })}
        </>
      )}
    </EmployeesPageContainer>
  );
};

export default Employees;
